/**
 * NotFound Page (404)
 */

import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Home, ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="not-found-page">
      <Navbar />

      <main className="flex-1 flex items-center justify-center px-4 pt-24">
        <div className="text-center max-w-md">
          <div style={{ fontFamily: "'Montserrat', sans-serif" }} className="text-9xl font-black text-[#0f2d52]/10 mb-4">
            404
          </div>
          <h1 style={{ fontFamily: "'Montserrat', sans-serif" }} className="text-3xl md:text-4xl font-black text-[#0f2d52] mb-4">
            Page Not Found
          </h1>
          <p style={{ fontFamily: "'Inter', sans-serif" }} className="text-gray-500 mb-8">
            Sorry, the page you're looking for doesn't exist or has been moved.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <button className="btn-primary flex items-center gap-2 w-full sm:w-auto justify-center">
                <Home size={16} /> Go Home
              </button>
            </Link>
            <Link to="/contact">
              <button className="border-2 border-[#0f2d52] text-[#0f2d52] font-bold px-6 py-3 rounded-lg hover:bg-[#0f2d52] hover:text-white transition-colors flex items-center gap-2 w-full sm:w-auto justify-center">
                Contact Us <ArrowRight size={16} />
              </button>
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
